"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  Hierarchy10: ['hierarchy-10', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,20.5a3.489,3.489,0,0,0-6.382-1.962.249.249,0,0,1-.283.1L7.164,15.4a.25.25,0,0,1-.173-.266A1.172,1.172,0,0,0,7,15a1.006,1.006,0,0,0-.008-.124.251.251,0,0,1,.18-.268l10.776-3.078a.248.248,0,0,1,.236.055A3.435,3.435,0,0,0,20.5,12.5a3.5,3.5,0,0,0,0-7,3.468,3.468,0,0,0-2.584,1.166.251.251,0,0,1-.262.071L7.146,3.392a.248.248,0,0,1-.173-.215A3.494,3.494,0,1,0,3.5,7,3.468,3.468,0,0,0,6.084,5.833a.251.251,0,0,1,.262-.071l9.942,3.163a.25.25,0,0,1-.007.479L5.942,12.358a.25.25,0,0,1-.229-.048A3.449,3.449,0,0,0,3.5,11.5a3.5,3.5,0,0,0,0,7,3.461,3.461,0,0,0,2.22-.815.248.248,0,0,1,.236-.046L16.93,21.13a.248.248,0,0,1,.168.18A3.5,3.5,0,0,0,24,20.5Z']],
  Hierarchy2: ['hierarchy-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.5,12.5H19.249a.25.25,0,0,1-.25-.25V10a2.5,2.5,0,0,0-2.5-2.5h-8A.5.5,0,0,1,8,7V4.249A.25.25,0,0,1,8.249,4H12a1.5,1.5,0,0,0,1.5-1.5v-1A1.5,1.5,0,0,0,12,0H1.5A1.5,1.5,0,0,0,0,1.5v1A1.5,1.5,0,0,0,1.5,4H5.749a.25.25,0,0,1,.25.25V7A2.5,2.5,0,0,0,8.5,9.5h8a.5.5,0,0,1,.5.5v2.25a.25.25,0,0,1-.25.25H12A1.5,1.5,0,0,0,10.5,14v1A1.5,1.5,0,0,0,12,16.5h4.75a.25.25,0,0,1,.25.25v3a.25.25,0,0,1-.25.25H12a1.5,1.5,0,0,0-1.5,1.5v1A1.5,1.5,0,0,0,12,24H22.5A1.5,1.5,0,0,0,24,22.5v-1A1.5,1.5,0,0,0,22.5,20H19.249a.25.25,0,0,1-.25-.25v-3a.25.25,0,0,1,.25-.25H22.5A1.5,1.5,0,0,0,24,15V14A1.5,1.5,0,0,0,22.5,12.5Z']],
  Hierarchy5: ['hierarchy-5', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,19.5A1.5,1.5,0,0,0,22.5,18h-.75a.25.25,0,0,1-.25-.25V12.5a2,2,0,0,0-2-2H13.25a.25.25,0,0,1-.25-.25v-5A.25.25,0,0,1,13.25,5H18.5A1.5,1.5,0,0,0,20,3.5v-2A1.5,1.5,0,0,0,18.5,0H5.5A1.5,1.5,0,0,0,4,1.5v2A1.5,1.5,0,0,0,5.5,5h5.25a.25.25,0,0,1,.25.25v5a.25.25,0,0,1-.25.25H4.5a2,2,0,0,0-2,2v5.25a.25.25,0,0,1-.25.25H1.5A1.5,1.5,0,0,0,0,19.5v3A1.5,1.5,0,0,0,1.5,24h3A1.5,1.5,0,0,0,6,22.5v-3a1.5,1.5,0,0,0-1.286-1.485.25.25,0,0,1-.214-.247V12.749a.25.25,0,0,1,.25-.25h6a.25.25,0,0,1,.25.25v5a.25.25,0,0,1-.25.25H10.5A1.5,1.5,0,0,0,9,19.5v3A1.5,1.5,0,0,0,10.5,24h3A1.5,1.5,0,0,0,15,22.5v-3A1.5,1.5,0,0,0,13.5,18h-.25a.25.25,0,0,1-.25-.25v-5a.25.25,0,0,1,.25-.25h6a.25.25,0,0,1,.25.25v5.018a.25.25,0,0,1-.214.247A1.5,1.5,0,0,0,18,19.5v3A1.5,1.5,0,0,0,19.5,24h3A1.5,1.5,0,0,0,24,22.5Z']],
  Hierarchy4: ['hierarchy-4', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.5,19A1.5,1.5,0,0,0,22,17.5h-.3a.249.249,0,0,1-.248-.224A7,7,0,0,0,14.5,11H13.25a.25.25,0,0,1-.25-.25v-4a.25.25,0,0,1,.25-.25h.25A1.5,1.5,0,0,0,15,5V2A1.5,1.5,0,0,0,13.5.5h-3A1.5,1.5,0,0,0,9,2V5a1.5,1.5,0,0,0,1.5,1.5h.25a.25.25,0,0,1,.25.25v4a.25.25,0,0,1-.25.25H9.5a7,7,0,0,0-6.955,6.276A.249.249,0,0,1,2.3,17.5H2A1.5,1.5,0,0,0,.5,19v3A1.5,1.5,0,0,0,2,23.5H5A1.5,1.5,0,0,0,6.5,22V19A1.5,1.5,0,0,0,5,17.5H4.835a.248.248,0,0,1-.19-.088.252.252,0,0,1-.057-.2A4.987,4.987,0,0,1,9.5,13h1.25a.25.25,0,0,1,.25.25v4a.25.25,0,0,1-.25.25H10.5A1.5,1.5,0,0,0,9,19v3a1.5,1.5,0,0,0,1.5,1.5h3A1.5,1.5,0,0,0,15,22V19a1.5,1.5,0,0,0-1.5-1.5h-.25a.25.25,0,0,1-.25-.25v-4a.25.25,0,0,1,.25-.25H14.5a4.987,4.987,0,0,1,4.912,4.21.255.255,0,0,1-.057.2.248.248,0,0,1-.19.088H19A1.5,1.5,0,0,0,17.5,19v3A1.5,1.5,0,0,0,19,23.5h3A1.5,1.5,0,0,0,23.5,22Z']],
  Hierarchy1: ['hierarchy-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21,0a3,3,0,0,0-3,3,2.971,2.971,0,0,0,.876,2.1.25.25,0,0,1,.05.279l-2.7,5.979a.25.25,0,0,1-.233.147,2.9,2.9,0,0,0-1.945.726.251.251,0,0,1-.276.035l-2.651-1.327a.249.249,0,0,1-.138-.244A2.993,2.993,0,1,0,5.8,12.531a.251.251,0,0,1,.04.281L3.328,17.875a.25.25,0,0,1-.235.139A2.993,2.993,0,1,0,6,21a2.978,2.978,0,0,0-.8-2.032.251.251,0,0,1-.04-.281l2.513-5.064a.25.25,0,0,1,.234-.139,2.9,2.9,0,0,0,2.049-.716.25.25,0,0,1,.275-.035l2.652,1.326a.251.251,0,0,1,.138.244,2.993,2.993,0,1,0,5.98.2,2.969,2.969,0,0,0-.876-2.1.251.251,0,0,1-.05-.28l2.7-5.983a.252.252,0,0,1,.23-.147A2.995,2.995,0,1,0,21,0Z']],
  Hierarchy3: ['hierarchy-3', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,12.5A1.5,1.5,0,0,0,22.5,11H15.25a.25.25,0,0,1-.25-.25V9a2.5,2.5,0,0,0-2.5-2.5h-4A.5.5,0,0,1,8,6V4.249A.25.25,0,0,1,8.25,4H12a1.5,1.5,0,0,0,1.5-1.5v-1A1.5,1.5,0,0,0,12,0H1.5A1.5,1.5,0,0,0,0,1.5v1A1.5,1.5,0,0,0,1.5,4H5.75a.25.25,0,0,1,.25.25V6A2.5,2.5,0,0,0,8.5,8.5h4A.5.5,0,0,1,13,9v1.75a.25.25,0,0,1-.25.25H12a1.5,1.5,0,0,0-1.5,1.5v1A1.5,1.5,0,0,0,12,15h5.25a.25.25,0,0,1,.25.25V20.5a.5.5,0,0,1-.5.5H13.555a.22.22,0,0,1-.2-.127A1.5,1.5,0,0,0,12,20H1.5A1.5,1.5,0,0,0,0,21.5v1A1.5,1.5,0,0,0,1.5,24H12a1.5,1.5,0,0,0,1.356-.873.218.218,0,0,1,.2-.127H17a2.5,2.5,0,0,0,2.5-2.5v-5.25a.25.25,0,0,1,.25-.25H22.5A1.5,1.5,0,0,0,24,13.5Z']],
  HierarchyFiles: ['hierarchy-files', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.25,3a.5.5,0,0,0,.5.5h2.4a.25.25,0,0,0,.213-.119.248.248,0,0,0,.011-.243,2.7,2.7,0,0,0-.482-.7L18.311.852a2.727,2.727,0,0,0-.7-.481.249.249,0,0,0-.361.223Z', 'M17.75,4.5A1.5,1.5,0,0,1,16.25,3V.249A.25.25,0,0,0,16,0H13.25a1.5,1.5,0,0,0-1.5,1.5v8a1.5,1.5,0,0,0,1.5,1.5h6a1.5,1.5,0,0,0,1.5-1.5V4.749a.25.25,0,0,0-.25-.25Z', 'M17.75,17.5a1.5,1.5,0,0,1-1.5-1.5v-2.75A.25.25,0,0,0,16,13H13.25a1.5,1.5,0,0,0-1.5,1.5v8a1.5,1.5,0,0,0,1.5,1.5h6a1.5,1.5,0,0,0,1.5-1.5v-4.75a.25.25,0,0,0-.25-.25Z', 'M17.25,16a.5.5,0,0,0,.5.5h2.4a.25.25,0,0,0,.213-.119.248.248,0,0,0,.011-.243,2.7,2.7,0,0,0-.482-.7l-1.585-1.586a2.727,2.727,0,0,0-.7-.481.249.249,0,0,0-.361.223Z', 'M4.25,3a1,1,0,0,0,1-1V1a1,1,0,0,0-2,0V2A1,1,0,0,0,4.25,3Z', 'M4.25,10a1,1,0,0,0,1-1V8a1,1,0,1,0-2,0V9A1,1,0,0,0,4.25,10Z', 'M5.25,4h-1a1,1,0,1,0,0,2h1a1,1,0,1,0,0-2Z', 'M3.25,13a1,1,0,1,0,2,0V12a1,1,0,0,0-2,0Z', 'M3.25,17a1,1,0,0,0,2,0V16a1,1,0,0,0-2,0Z', 'M5.25,19h-1a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z', 'M9.25,4h-1a1,1,0,0,0,0,2h1a1,1,0,1,0,0-2Z', 'M9.25,19h-1a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z']],
  Hierarchy9: ['hierarchy-9', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.5,5A2.5,2.5,0,1,0,19,2.5a2.426,2.426,0,0,0,.126.766.251.251,0,0,1-.061.255L16.4,6.193a.25.25,0,0,1-.307.037A4.972,4.972,0,0,0,9.533,7.47a.248.248,0,0,1-.3.075L5.074,5.615A.128.128,0,0,1,5,5.5,2.5,2.5,0,1,0,2.5,8a2.463,2.463,0,0,0,1.511-.523.252.252,0,0,1,.259-.029L8.433,9.381a.252.252,0,0,1,.141.27A4.936,4.936,0,0,0,9.233,13.1a.25.25,0,0,1-.037.307L3.522,19.064a.251.251,0,0,1-.255.061A2.437,2.437,0,0,0,2.5,19,2.5,2.5,0,1,0,5,21.5a2.448,2.448,0,0,0-.125-.765.25.25,0,0,1,.061-.256l5.68-5.665a.251.251,0,0,1,.306-.037,4.967,4.967,0,0,0,1.387.579.25.25,0,0,1,.19.243v3.474a.221.221,0,0,1-.12.2,2.5,2.5,0,1,0,2.256.007.249.249,0,0,1-.136-.222V15.6a.25.25,0,0,1,.19-.243,4.982,4.982,0,0,0,2.427-1.437.25.25,0,0,1,.291-.055l1.477.709a.254.254,0,0,1,.141.2,2.492,2.492,0,1,0,.809-2.132.249.249,0,0,1-.275.039l-1.134-.543a.251.251,0,0,1-.132-.3A4.75,4.75,0,0,0,18.5,10.5a4.958,4.958,0,0,0-.725-2.582.251.251,0,0,1,.036-.307l2.669-2.676a.252.252,0,0,1,.255-.061A2.431,2.431,0,0,0,21.5,5Z']],
  Hierarchy8: ['hierarchy-8', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20.5,15.5h-.038a.5.5,0,0,1-.451-.247L15.154,7a.5.5,0,0,1-.018-.476A3.41,3.41,0,0,0,15.5,5a3.5,3.5,0,0,0-7,0,3.41,3.41,0,0,0,.364,1.52A.5.5,0,0,1,8.846,7L3.988,15.253a.5.5,0,0,1-.45.247H3.5a3.5,3.5,0,1,0,3.137,5.03.5.5,0,0,1,.449-.28h9.828a.5.5,0,0,1,.449.28A3.5,3.5,0,1,0,20.5,15.5ZM7.085,17.749a.5.5,0,0,1-.448-.277A3.37,3.37,0,0,0,6.28,16.9a.5.5,0,0,1-.034-.558l4.525-7.693a.5.5,0,0,1,.541-.235,2.962,2.962,0,0,0,1.376,0,.5.5,0,0,1,.541.235l4.524,7.691a.5.5,0,0,1-.034.558,3.48,3.48,0,0,0-.356.569.5.5,0,0,1-.448.278Z']],
  HierarchyFiles1: ['hierarchy-files-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18,3a.5.5,0,0,0,.5.5h2.4a.25.25,0,0,0,.213-.119.248.248,0,0,0,.011-.243,2.7,2.7,0,0,0-.482-.7L19.061.852a2.727,2.727,0,0,0-.7-.481A.249.249,0,0,0,18,.594Z', 'M18.5,4.5A1.5,1.5,0,0,1,17,3V.249A.25.25,0,0,0,16.75,0H14a1.5,1.5,0,0,0-1.5,1.5v8A1.5,1.5,0,0,0,14,11h6a1.5,1.5,0,0,0,1.5-1.5v-5Z', 'M18.5,17.5A1.5,1.5,0,0,1,17,16v-2.75a.25.25,0,0,0-.25-.25H14a1.5,1.5,0,0,0-1.5,1.5v8A1.5,1.5,0,0,0,14,24h6a1.5,1.5,0,0,0,1.5-1.5v-4.75a.25.25,0,0,0-.25-.25Z', 'M18,16a.5.5,0,0,0,.5.5h2.4a.25.25,0,0,0,.213-.119.248.248,0,0,0,.011-.243,2.7,2.7,0,0,0-.482-.7l-1.585-1.586a2.727,2.727,0,0,0-.7-.481.249.249,0,0,0-.361.223Z', 'M3.5,13a1,1,0,0,0,1-1V9a1,1,0,0,0-2,0v3A1,1,0,0,0,3.5,13Z', 'M4.7,4.019a.25.25,0,0,1-.2-.245V2a1,1,0,0,0-2,0V5a1,1,0,0,0,1,1h1a1,1,0,0,0,.2-1.98Z', 'M10,4H8A1,1,0,0,0,8,6h2a1,1,0,1,0,0-2Z', 'M4.7,18.019a.25.25,0,0,1-.2-.245V16a1,1,0,0,0-2,0v3a1,1,0,0,0,1,1h1a1,1,0,0,0,.2-1.98Z', 'M10,18H8a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z']],
  Hierarchy7: ['hierarchy-7', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,19.5A4.5,4.5,0,0,0,19.5,15a4.28,4.28,0,0,0-.875.1.249.249,0,0,1-.275-.133L14.934,8.13a.249.249,0,0,1,.056-.3,4.5,4.5,0,1,0-5.98,0,.252.252,0,0,1,.057.3L5.649,14.964a.248.248,0,0,1-.275.132A4.263,4.263,0,0,0,4.5,15a4.5,4.5,0,1,0,4.333,5.684.249.249,0,0,1,.241-.184h5.852a.25.25,0,0,1,.241.184A4.5,4.5,0,0,0,24,19.5Zm-8.833-1.184a.249.249,0,0,1-.241.184H9.074a.25.25,0,0,1-.241-.184A4.482,4.482,0,0,0,7.49,16.166a.249.249,0,0,1-.056-.3l3.417-6.834a.249.249,0,0,1,.275-.133,3.951,3.951,0,0,0,1.749,0,.252.252,0,0,1,.275.133l3.416,6.834a.249.249,0,0,1-.056.3A4.482,4.482,0,0,0,15.167,18.315Z']],
  Hierarchy6: ['hierarchy-6', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,16.5A1.5,1.5,0,0,0,22.5,15h-1a.25.25,0,0,1-.25-.25V13.5a1.752,1.752,0,0,0-1.75-1.75h-5a.25.25,0,0,1-.25-.25V9.249A.25.25,0,0,1,14.5,9h2A1.5,1.5,0,0,0,18,7.5v-6A1.5,1.5,0,0,0,16.5,0h-7A1.5,1.5,0,0,0,8,1.5v6A1.5,1.5,0,0,0,9.5,9h3a.25.25,0,0,1,.25.25V11.5a.25.25,0,0,1-.25.25h-8A1.752,1.752,0,0,0,2.75,13.5v1.25A.25.25,0,0,1,2.5,15h-1A1.5,1.5,0,0,0,0,16.5v6A1.5,1.5,0,0,0,1.5,24h7A1.5,1.5,0,0,0,10,22.5v-6A1.5,1.5,0,0,0,8.5,15h-4a.25.25,0,0,1-.25-.25V13.5a.253.253,0,0,1,.25-.25h15a.253.253,0,0,1,.25.25v1.25a.25.25,0,0,1-.25.25h-4A1.5,1.5,0,0,0,14,16.5v6A1.5,1.5,0,0,0,15.5,24h7A1.5,1.5,0,0,0,24,22.5ZM11.5,4.249a.75.75,0,0,1,0-1.5h3a.75.75,0,1,1,0,1.5Zm-8,13.5h3a.75.75,0,0,1,0,1.5h-3a.75.75,0,0,1,0-1.5Zm17,0a.75.75,0,0,1,0,1.5h-3a.75.75,0,0,1,0-1.5Z']],
  Hierarchy: ['hierarchy', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.13,18.233a.248.248,0,0,1-.155-.214A7,7,0,0,0,15,11.5H13.25a.25.25,0,0,1-.25-.25V5.986a.251.251,0,0,1,.153-.231,3,3,0,1,0-2.306,0A.251.251,0,0,1,11,5.986v5.263a.25.25,0,0,1-.25.25H8.5a6.557,6.557,0,0,0-6.478,6.519.252.252,0,0,1-.155.217,3,3,0,1,0,2.32.021.252.252,0,0,1-.15-.249A4.527,4.527,0,0,1,8.5,13.5h2.25a.25.25,0,0,1,.25.25v4.263a.251.251,0,0,1-.153.231,3,3,0,1,0,2.306,0A.251.251,0,0,1,13,18.012V13.749a.25.25,0,0,1,.25-.25H15a4.992,4.992,0,0,1,4.954,4.506.25.25,0,0,1-.149.254,3,3,0,1,0,2.325-.026Z']]
};
exports["default"] = _default;